/* Keep Shopify/Recharge's purchasing handlers; improve names and keyboard access. */
(() => {
  const scan = () => {
    if (location.pathname.startsWith('/collections/')) {
      document.querySelectorAll('p').forEach(paragraph => {
        paragraph.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Select your preferred delivery date at checkout.')) {
            node.textContent = node.textContent.replace('Select your preferred delivery date at checkout.', 'Choose your delivery date in the basket.');
          }
        });
      });
    }
    if (location.pathname === '/collections/subscribe-save-10') {
      document.querySelectorAll('h1').forEach(heading => {
        if (heading.textContent.trim() === 'Smoked salmon for every table.') heading.textContent = 'Standing orders';
      });
    }
    document.querySelectorAll('.quantity-selector .js-qty__adjust').forEach(control => {
      control.setAttribute('role', 'button');
      control.setAttribute('aria-label', control.classList.contains('js-qty__adjust--plus')
        ? 'Increase quantity' : 'Decrease quantity');
      control.setAttribute('tabindex', '0');
    });
    document.querySelectorAll('.selector-wrapper label, .selector-wrapper legend').forEach(label => {
      for (const node of label.childNodes) {
        if (node.nodeType !== Node.TEXT_NODE) continue;
        if (node.textContent.trim() === 'Title') node.textContent = 'Gift card value ';
        if (node.textContent.trim() === 'Vacuum Packed or Loose') node.textContent = 'Packaging ';
      }
    });
    if (document.body.classList.contains('shop-recurring-template')) {
      document.querySelectorAll('.rc-login-form-button, .rc-login button[type="submit"]').forEach(button => {
        const labels = [...button.querySelectorAll('span')].filter(span =>
          /send login code/i.test(span.textContent) && !span.querySelector('span'));
        if (labels.length) labels.forEach(span => { span.textContent = 'Email my sign-in code'; });
        else if (/send login code/i.test(button.textContent)) button.textContent = 'Email my sign-in code';
        button.setAttribute('aria-label', 'Email my sign-in code');
      });
      document.querySelectorAll('.rc-login h1, .rc-login h2, .rc-login h3').forEach(heading => {
        if (heading.textContent.trim() === 'Login') heading.textContent = 'Manage your standing order';
      });
    }
  };
  document.addEventListener('keydown', event => {
    const control = event.target.closest('.quantity-selector .js-qty__adjust');
    if (!control || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (!control.disabled && control.getAttribute('aria-disabled') !== 'true') control.click();
  });
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  scan();
})();
